const consolidatedMonthlyLineItemTemplate = (() => {
    const main = {
        "1": {
          "config": {
            "class": "container"
          },
          "tag": "div",
          "parent": -1
        },
        "2": {
          "config": {
            "class": "monthly-summery"
          },
          "tag": "div",
          "parent": 1
        },
        "3": {
          "config": {
            "class": "row pt-3"
          },
          "tag": "div",
          "parent": 2
        },
        "4": {
          "config": {
            "class": "col-3"
          },
          "tag": "div",
          "parent": 3
        },
        "5": {
          "config": {
            "class": "pb-0"
          },
          "tag": "h4",
          "parent": 4,
          "html": "{value}"
        },
        "6": {
          "config": {
            "class": "col"
          },
          "tag": "div",
          "parent": 3
        },
        "7": {
          "config": {
            "class": "form-inline"
          },
          "tag": "form",
          "parent": 6
        },
        "8": {
          "config": {},
          "tag": "fieldset",
          "parent": 7
        },
        "9": {
          "config": {
            "class": "sr-only"
          },
          "tag": "legend",
          "parent": 8,
          "html": "select"
        },
        "10": {
          "config": {
            "class": "input-group mb-2"
          },
          "tag": "div",
          "parent": 8
        },
        "11": {
          "config": {
            "class": "fonr-control",
            "for": "monthySummary"
          },
          "tag": "label",
          "parent": 10,
          "html": "Select"
        },
        "12": {
          "config": {
            "class": "custom-select ml-3 accountNumberConsolidatedMonthlyLineItemFilter",
            "id": "accountNumberMonthlyLineItem"
          },
          "tag": "select",
          "parent": 10,
          "events": [
              {
                  "id": "accountNumberMonthlyLineItem",
                  "name": "change",
                  "callback": "getMonthlyLineItemSelectedValue"
              }
          ]
        },
        "17": {
          "config": {
            "class": "col-3"
          },
          "tag": "div",
          "parent": 3
        },
        "18": {
          "config": {
            "style": { "display":"none"},
            "class": "nav nav-tabs graphicalView float-right"
          },
          "tag": "ul",
          "parent": 17
        },
        "19": {
          "config": {
            "class": "nav-item"
          },
          "tag": "li",
          "parent": 18
        },
        "20": {
          "config": {
            "class": "nav-link",
            "id": "hideShowGraphicalView",
            "data-toggle": "tab",
            "href": "#graphicalView"
          },
          "tag": "a",
          "parent": 19,
          "html": "Graphical View",
          "events": [
            {
                "id": "hideShowGraphicalView",
                "name": "click",
                "callback": "hideShowSections"
            }
        ]
        },
        "21": {
          "config": {
            "class": "nav-item"
          },
          "tag": "li",
          "parent": 18
        },
        "22": {
          "config": {
            "class": "nav-link tableview",
            "id": "hideShowTableView",
            "data-toggle": "tab",
            "href": "#tableView"
          },
          "tag": "a",
          "parent": 21,
          "html": "Table View",
          "events": [
            {
                "id": "hideShowTableView",
                "name": "click",
                "callback": "hideShowSections"
            }
        ]
        },
        "23": {
          "config": {
            "style": { "display":"none"},
            "class": "payment-graph mt-3 hideShowSection1",
            "id": "graphicalView",
          },
          "tag": "div",
          "parent": 1
        },
        "24": {
          "config": {
            "class": "row"
          },
          "tag": "div",
          "parent": 23
        },
        "25": {
          "config": {
            "class": "col-6"
          },
          "tag": "div",
          "parent": 24
        },
        "26": {
          "config": {
            "class": "card p-3 pt-4"
          },
          "tag": "div",
          "parent": 25
        },
        "27": {
          "config": {
            "class": "card-body p-0 text-center"
          },
          "tag": "div",
          "parent": 26
        },
        "28": {
          "config": {},
          "tag": "h5",
          "parent": 27,
          "html": "Credit"
        },
        "29": {
          "config": {
            "class": "graph",
            "id": "monthlyLineItemCreditChart"
          },
          "tag": "div",
          "parent": 27
        },
        "31": {
          "config": {
            "class": "col-6"
          },
          "tag": "div",
          "parent": 24
        },
        "32": {
          "config": {
            "class": "card p-3 pt-4"
          },
          "tag": "div",
          "parent": 31
        },
        "33": {
          "config": {
            "class": "card-body p-0 text-center"
          },
          "tag": "div",
          "parent": 32
        },
        "34": {
          "config": {},
          "tag": "h5",
          "parent": 33,
          "html": "Debit"
        },
        "35": {
          "config": {
            "class": "graph",
            "id": "monthlyLineItemDebitChart"
          },
          "tag": "div",
          "parent": 33
        },
        "37": {
          "config": {
            "id": "tableview",
            "class": "listStatement card p-0 hideShowSection2"
          },
          "tag": "div",
          "parent": 1
        },
        "38": {
          "config": {
            "class": "data-wrap-fixed row m-0 shadowNone"
          },
          "tag": "div",
          "parent": 37
        },
        "39": {
          "config": {
            "class": "col-1 dataLeft-fixed p-0 monthlyLineItemLeft"
          },
          "tag": "div",
          "parent": 38
        },
        "40": {
          "config": {
            "class": "col-2 dataLeft-fixed p-0 monthlyLineItemLeft1"
          },
          "tag": "div",
          "parent": 38
        },
        "51": {
          "config": {
            "class": "col-9 p-0"
          },
          "tag": "div",
          "parent": 38
        },
        "52": {
          "config": {
            "class": "mid-panel monthlyLineItemMidPanel"
          },
          "tag": "div",
          "parent": 51
        },
        "53": {
          "config": {
            "class": "data-head monthlyLineItemDataHead"
          },
          "tag": "div",
          "parent": 52
        },
      };

    return {
        main
    };
})();
